import * as React from 'react';
import { Portal, Snackbar } from '@mui/material';
import { Alert } from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
    type?: 'success' | 'info' | 'warning' | 'error';
}

const LrToastNotify: React.FunctionComponent<Props> = (props) => {
    const { open, onClose, children, type } = { ...props };
    return (
        <Portal>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={open}
                onClose={onClose}
                autoHideDuration={6000}
            >
                <Alert variant="outlined" onClose={onClose} severity={type}>
                    {children}
                </Alert>
            </Snackbar>
        </Portal>
    );
};

LrToastNotify.defaultProps = { type: 'success' };
export default LrToastNotify;
